import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

export const HeroSection = ({ t, scrollToSection }) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_67b366a2-9c46-4ca8-9e2f-e7e30db89ded/artifacts/hhh64grw_Imagen%20fondo%20de%20portada.png"
          alt="SAFEX PHARMA Laboratory"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-white/30"></div>
      </div>

      {/* SFX Academy Button - Top Right */}
      <button
        onClick={() => scrollToSection('protocols')}
        className="absolute top-28 right-6 lg:right-12 z-20 hover:scale-105 transition-transform duration-300"
        data-testid="hero-sfx-academy-btn"
      >
        <img 
          src="https://customer-assets.emergentagent.com/job_67b366a2-9c46-4ca8-9e2f-e7e30db89ded/artifacts/l09pv0l3_Boton%20secci%C3%B3n%20Sfx%20Academy.png"
          alt="SFX Academy"
          className="h-20 lg:h-36 w-auto rounded-2xl shadow-xl"
        />
      </button>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center z-10">
        <div className="space-y-8 animate-fadeIn">
          {/* Badge */}
          <div className="inline-flex items-center px-5 py-3 rounded-full bg-white/80 backdrop-blur-sm border border-slate-200 shadow-sm">
            <Sparkles className="w-5 h-5 text-[#545454] mr-2" />
            <span className="text-sm font-semibold text-[#545454]">{t.hero.subtitle}</span>
          </div>

          {/* Main Title */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-[#545454] leading-tight">
            {t.hero.title}
          </h1>

          {/* Description */}
          <p className="text-xl sm:text-2xl text-[#545454]/80 max-w-3xl mx-auto leading-relaxed">
            {t.hero.description}
          </p>

          {/* CTA Button */}
          <div className="flex justify-center items-center pt-8">
            <Button
              onClick={() => scrollToSection('products')}
              size="lg"
              data-testid="hero-explore-btn"
              className="bg-[#96c7ca] hover:bg-[#7fb8bb] text-black px-10 py-6 text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 group"
            >
              {t.hero.ctaPrimary}
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-6">
          {t.experience.stats.map((stat, index) => (
            <div key={index} className="text-center space-y-2 p-6 rounded-xl bg-white/80 backdrop-blur-sm shadow-md border border-white/50 hover:shadow-lg hover:scale-105 transition-all duration-300">
              <div className="text-5xl font-bold text-[#545454]">{stat.value}</div>
              <div className="text-sm text-[#545454]/70 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-20">
        <div className="w-6 h-10 border-2 border-[#545454]/40 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-[#545454]/60 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};
